"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDpadToFocusDirection = exports.isVerticalDirection = exports.isHorizontalDirection = exports.invertFocusDirection = exports.FocusDirection = void 0;
const gamepad_1 = require("./gamepad");
var FocusDirection;
(function (FocusDirection) {
    FocusDirection["Up"] = "Up";
    FocusDirection["Down"] = "Down";
    FocusDirection["Left"] = "Left";
    FocusDirection["Right"] = "Right";
})(FocusDirection || (exports.FocusDirection = FocusDirection = {}));
const invertFocusDirection = (direction) => {
    switch (direction) {
        case FocusDirection.Up:
            return FocusDirection.Down;
        case FocusDirection.Down:
            return FocusDirection.Up;
        case FocusDirection.Left:
            return FocusDirection.Right;
        case FocusDirection.Right:
            return FocusDirection.Left;
    }
};
exports.invertFocusDirection = invertFocusDirection;
const isHorizontalDirection = (direction) => {
    return direction === FocusDirection.Left || direction === FocusDirection.Right;
};
exports.isHorizontalDirection = isHorizontalDirection;
const isVerticalDirection = (direction) => {
    return direction === FocusDirection.Up || direction === FocusDirection.Down;
};
exports.isVerticalDirection = isVerticalDirection;
const mapDpadToFocusDirection = (button) => {
    switch (button) {
        case gamepad_1.GamepadButton.DpadUp:
            return FocusDirection.Up;
        case gamepad_1.GamepadButton.DpadDown:
            return FocusDirection.Down;
        case gamepad_1.GamepadButton.DpadLeft:
            return FocusDirection.Left;
        case gamepad_1.GamepadButton.DpadRight:
            return FocusDirection.Right;
        default:
            return undefined;
    }
};
exports.mapDpadToFocusDirection = mapDpadToFocusDirection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9jdXNEaXJlY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMvZm9jdXNEaXJlY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELHVDQUEwQztBQUUxQyxJQUFZLGNBS1g7QUFMRCxXQUFZLGNBQWM7SUFDdEIsMkJBQVMsQ0FBQTtJQUNULCtCQUFhLENBQUE7SUFDYiwrQkFBYSxDQUFBO0lBQ2IsaUNBQWUsQ0FBQTtBQUNuQixDQUFDLEVBTFcsY0FBYyw4QkFBZCxjQUFjLFFBS3pCO0FBRU0sTUFBTSxvQkFBb0IsR0FBRyxDQUFDLFNBQXlCLEVBQWtCLEVBQUU7SUFDOUUsUUFBUSxTQUFTLEVBQUUsQ0FBQztRQUNoQixLQUFLLGNBQWMsQ0FBQyxFQUFFO1lBQ2xCLE9BQU8sY0FBYyxDQUFDLElBQUksQ0FBQztRQUMvQixLQUFLLGNBQWMsQ0FBQyxJQUFJO1lBQ3BCLE9BQU8sY0FBYyxDQUFDLEVBQUUsQ0FBQztRQUM3QixLQUFLLGNBQWMsQ0FBQyxJQUFJO1lBQ3BCLE9BQU8sY0FBYyxDQUFDLEtBQUssQ0FBQztRQUNoQyxLQUFLLGNBQWMsQ0FBQyxLQUFLO1lBQ3JCLE9BQU8sY0FBYyxDQUFDLElBQUksQ0FBQztJQUNuQyxDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBWFcsUUFBQSxvQkFBb0Isd0JBVy9CO0FBRUssTUFBTSxxQkFBcUIsR0FBRyxDQUFDLFNBQTBCLEVBQVcsRUFBRTtJQUN6RSxPQUFPLFNBQVMsS0FBSyxjQUFjLENBQUMsSUFBSSxJQUFJLFNBQVMsS0FBSyxjQUFjLENBQUMsS0FBSyxDQUFDO0FBQ25GLENBQUMsQ0FBQztBQUZXLFFBQUEscUJBQXFCLHlCQUVoQztBQUNLLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxTQUEwQixFQUFXLEVBQUU7SUFDdkUsT0FBTyxTQUFTLEtBQUssY0FBYyxDQUFDLEVBQUUsSUFBSSxTQUFTLEtBQUssY0FBYyxDQUFDLElBQUksQ0FBQztBQUNoRixDQUFDLENBQUM7QUFGVyxRQUFBLG1CQUFtQix1QkFFOUI7QUFFSyxNQUFNLHVCQUF1QixHQUFHLENBQUMsTUFBcUIsRUFBOEIsRUFBRTtJQUN6RixRQUFRLE1BQU0sRUFBRSxDQUFDO1FBQ2IsS0FBSyx1QkFBYSxDQUFDLE1BQU07WUFDckIsT0FBTyxjQUFjLENBQUMsRUFBRSxDQUFDO1FBQzdCLEtBQUssdUJBQWEsQ0FBQyxRQUFRO1lBQ3ZCLE9BQU8sY0FBYyxDQUFDLElBQUksQ0FBQztRQUMvQixLQUFLLHVCQUFhLENBQUMsUUFBUTtZQUN2QixPQUFPLGNBQWMsQ0FBQyxJQUFJLENBQUM7UUFDL0IsS0FBSyx1QkFBYSxDQUFDLFNBQVM7WUFDeEIsT0FBTyxjQUFjLENBQUMsS0FBSyxDQUFDO1FBQ2hDO1lBQ0ksT0FBTyxTQUFTLENBQUM7SUFDekIsQ0FBQztBQUNMLENBQUMsQ0FBQztBQWJXLFFBQUEsdUJBQXVCLDJCQWFsQyJ9